import request from '@/utils/request'
import { resolveAssetUrl } from '@/utils/api'

const getData = (response) => response?.data || {}

const normalizeNewsCard = (item = {}) => ({
    ...item,
    image: resolveAssetUrl(item.image || ''),
    cover: resolveAssetUrl(item.cover || item.image || ''),
})

const normalizeHomeColumn = (column = {}) => ({
    ...column,
    preview: column.preview
        ? {
            ...column.preview,
            image: resolveAssetUrl(column.preview.image || ''),
            cover: resolveAssetUrl(column.preview.cover || column.preview.image || ''),
        }
        : null,
})

const normalizeProjectDetail = (project = {}) => ({
    ...project,
    overviewHtml: project.overviewHtml || '',
    overviewBlocks: Array.isArray(project.overview)
        ? project.overview
        : Array.isArray(project.overviewBlocks)
            ? project.overviewBlocks
            : [],
    overview: Array.isArray(project.overview) ? project.overview : [],
    advantages: Array.isArray(project.advantages) ? project.advantages : [],
    conditions: Array.isArray(project.conditions) ? project.conditions : [],
    process: Array.isArray(project.process) ? project.process : [],
    processSteps: Array.isArray(project.processSteps) ? project.processSteps : [],
    documents: Array.isArray(project.documents) ? project.documents : [],
})

export function getHomeData() {
    return request.get('/api/home').then(getData).then((res) => {
        const data = res || {}
        return {
            ...data,
            hero: data.hero
                ? {
                    ...data.hero,
                    image: resolveAssetUrl(data.hero.image || ''),
                }
                : null,
            company: data.company
                ? {
                    ...data.company,
                    image: resolveAssetUrl(data.company.image || ''),
                }
                : null,
            advantages: Array.isArray(data.advantages)
                ? data.advantages.map((item) => ({
                    ...item,
                    icon: resolveAssetUrl(item.icon || ''),
                }))
                : [],
            newsColumns: Array.isArray(data.newsColumns)
                ? data.newsColumns.map(normalizeHomeColumn)
                : [],
        }
    })
}

export function getProjectList(params) {
    return request.get('/api/projects', { params }).then(getData)
}

export function getProjectDetail(id) {
    return request.get(`/api/projects/${id}`).then(getData).then(normalizeProjectDetail)
}

export function getNewsList(params) {
    return request.get('/api/news', { params }).then(getData).then((data) => ({
        ...data,
        list: Array.isArray(data.list) ? data.list.map(normalizeNewsCard) : [],
    }))
}

export function getNewsDetail(id) {
    return request.get(`/api/news/${id}`).then(getData).then((data) => ({
        ...data,
        desc: data.desc || '',
        image: resolveAssetUrl(data.image || ''),
        cover: resolveAssetUrl(data.cover || data.image || ''),
        relatedNews: Array.isArray(data.relatedNews) ? data.relatedNews : [],
        sideGroups: Array.isArray(data.sideGroups) ? data.sideGroups : [],
        content: Array.isArray(data.content) ? data.content : [],
        contentHtml: data.contentHtml || '',
    }))
}

export function getCategoryList() {
    return request.get('/api/categories').then(getData)
}

export function getSearchResult(params) {
    return request.get('/api/search', { params }).then(getData).then((data) => ({
        ...data,
        list: Array.isArray(data.list) ? data.list.map(normalizeNewsCard) : [],
    }))
}

export function getAboutData() {
    return request.get('/api/about').then(getData).then((data) => ({
        ...data,
        banner: data.banner
            ? {
                ...data.banner,
                image: resolveAssetUrl(data.banner.image || ''),
            }
            : null,
        coverImage: resolveAssetUrl(data.coverImage || ''),
        advantages: Array.isArray(data.advantages)
            ? data.advantages.map((item) => ({
                ...item,
                icon: resolveAssetUrl(item.icon || ''),
            }))
            : [],
        honors: Array.isArray(data.honors)
            ? data.honors.map((item) => ({
                ...item,
                image: resolveAssetUrl(item.image || ''),
            }))
            : [],
    }))
}

export function getContactData() {
    return request.get('/api/contact').then(getData).then((data) => {
        const normalizeContact = (item = {}) => ({
            ...item,
            mapImage: resolveAssetUrl(item.mapImage || ''),
        })

        return {
            ...data,
            shanghai: normalizeContact(data.shanghai),
            auckland: normalizeContact(data.auckland),
        }
    })
}

export function getSettingsData() {
    return request.get('/api/settings').then(getData).then((data) => ({
        ...data,
        logo: resolveAssetUrl(data.logo || ''),
        footer: data.footer
            ? {
                ...data.footer,
                qrSubscribe: resolveAssetUrl(data.footer.qrSubscribe || ''),
                qrService: resolveAssetUrl(data.footer.qrService || ''),
            }
            : null,
    }))
}
